"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    useNextVariants: true,
    fontFamily: ['proxima-nova', 'Arial', 'sans-serif'].join(','),
    fontSize: 16,
    inputSize: '18px',
    button: {
        fontSize: '16px'
    }
};
exports.default = typography;
//# sourceMappingURL=typography.js.map